import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Typewriter from "typewriter-effect";
import LoaderComp from "../LoaderComp";
import { getCallId } from "../Redux/UserSlice";
import { backendApi, callPlayBot } from "../services/service";
import "./Home.css";
const Home = (props) => {
  const call_id = useSelector(getCallId);
  console.log(call_id);
  const { setPage, languageContent, userData } = props;
  console.log(languageContent);
  const [showStartButton, setShowStartButton] = useState(false);
  const submitapis = async () => {
    await backendApi(call_id, "user_response", "success")
      .then((res) => {
        if (res.data) {
          console.log("continue");
        } else {
          setPage("home");
        }
      })
      .catch(() => setPage("home"));
    await backendApi(call_id, "welcome_page", "open")
      .then((res) => {
        if (res.data) {
          console.log("continue");
        } else {
          setPage("home");
        }
      })
      .catch(() => setPage("home"));
  };
  const handleHomeStart = async () => {
    await backendApi(call_id, "welcome_page_start", "clicked")
      .then((res) => {
        if (res.data) {
          console.log("continue");
          setPage("verification");
          // setPage("video");
        } else {
          setPage("landing");
        }
      })
      .catch(() => setPage("landing"));
  };
  const template_welcome_page = async () => {
    await callPlayBot(call_id, "welcome_page")
      .then((res) => {
        if (res.data === 200) {
          console.log("okay play api");
        }
      })
      .catch((e) => console.log(e.message));
  };

  useEffect(() => {
    template_welcome_page();
    submitapis();
  }, []);

  return (
    <>
      {Object.values(languageContent).length > 0 ? (
        <>
          <Typewriter
            options={{
              cursor: "",
              delay: 70,
            }}
            onInit={(typewriter) => {
              typewriter
                .typeString(
                  `<p style="color:#505050;font-size:45px;line-height:35px;  font-family: PF Handbook Pro; font-weight: 700">${languageContent.landing_page.hi} ${userData.policy_owner_name},</p>
                    <span style="color:#c7222a;font-size:30px;line-height:35px; font-family: PF Handbook Pro;font-weight: 700;">${languageContent.landing_page.heading_1a}</span><p style="color:#c7222a;font-size:15px;line-height:50px; font-family: PF Handbook Pro;font-weight: 700">${languageContent.landing_page.heading_1b} ${userData.application_number}</p>
                `
                )
                .callFunction(() => {
                  setShowStartButton(true);
                })
                .start();
            }}
          />
          {showStartButton && (
            <button className="myButton" onClick={handleHomeStart}>
              {languageContent.landing_page.start}
            </button>
          )}
        </>
      ) : (
        <LoaderComp />
      )}
    </>
  );
};

export default Home;
